import * as Styles from './UserMenuDropDown.styles';

export type UserMenuOptionType = {
  label: string;
  icon: JSX.Element;
  handleClickOnOption?: () => void;
  href?: string;
};

export type UserMenuDropDownProps = {
  options: UserMenuOptionType[];
  displayDropDown: boolean;
  username: string;
  initials: string;
  picture: string;
  handleClickOnUserMenu: () => void;
};

const UserMenuDropDownComponent = function ({
  options,
  displayDropDown,
  username,
  initials,
  picture,
  handleClickOnUserMenu,
}: UserMenuDropDownProps): JSX.Element {
  return (
    <Styles.UserNameMenuContainer>
      <Styles.UserNameMenu
        type="button"
        onClick={handleClickOnUserMenu}
        data-testid={`${username}-menu`}
      >
        <Styles.AvatarContainer>
          {picture ? (
            <Styles.Avatar src={picture} alt={`${username}-profile`} />
          ) : (
            <p>{initials}</p>
          )}
        </Styles.AvatarContainer>
        <Styles.UserName>{username}</Styles.UserName>
      </Styles.UserNameMenu>

      <Styles.DropDown data-testid={`${username}-menu-dropdown`}>
        {displayDropDown && (
          <>
            <Styles.Overlay
              key={`${username}-dropdown-menu`}
              onClick={handleClickOnUserMenu}
              data-testid="dropdown-overlay"
            />

            <Styles.OptionsContainer data-testid={`${username}-options`}>
              {options.map((option) => {
                if (option?.href) {
                  return (
                    <Styles.Link
                      to={option.href}
                      key={`${option.label}-dropdown-option`}
                      onClick={handleClickOnUserMenu}
                    >
                      <Styles.Option>
                        <Styles.OptionIcon>{option.icon}</Styles.OptionIcon>
                        <Styles.Label>{option.label}</Styles.Label>
                      </Styles.Option>
                    </Styles.Link>
                  );
                }

                if (option?.handleClickOnOption) {
                  return (
                    <Styles.Button
                      type="button"
                      key={`${option.label}-dropdown-option`}
                      onClick={option.handleClickOnOption}
                    >
                      <Styles.Option>
                        <Styles.OptionIcon>{option.icon}</Styles.OptionIcon>
                        <Styles.Label>{option.label}</Styles.Label>
                      </Styles.Option>
                    </Styles.Button>
                  );
                }

                return <div />;
              })}
            </Styles.OptionsContainer>
          </>
        )}
      </Styles.DropDown>
    </Styles.UserNameMenuContainer>
  );
};

export default UserMenuDropDownComponent;
